import React from 'react';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { InfoField, ChipBox } from '@occc/ui-design-system';
import { AwardVouchersFragment } from '@occc/graphql';

interface IVouchersAwardProps {
  award: AwardVouchersFragment;
}

export const VouchersAward: React.FC<IVouchersAwardProps> = ({ award }) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (id: string) => {
      navigate(`/offers/${id}`);
    },
    [navigate],
  );

  return (
    <Grid container spacing={2}>
      <Grid item md={3}>
        <InfoField label='Voucher Count' value={award?.voucherCount} />
      </Grid>
      <Grid item md={3}>
        <InfoField
          label='Voucher Offer'
          value={<ChipBox items={[award.voucheredOffer]} onClick={onChipClick} mt={0} />}
          disableTypography
        />
      </Grid>
      <Grid item md={3}>
        <InfoField label='Voucher Expiration Days' value={award?.voucherExpirationDays} />
      </Grid>
    </Grid>
  );
};
